const BRAND_COLOR_NAMES = [
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
  "950",
];

const hexToRgbChannels = (hex) => {
  const normalized = hex.replace("#", "");
  const pairs = normalized.match(/.{1,2}/g);

  if (!pairs || pairs.length !== 3) {
    return "114 9 183";
  }

  return pairs.map((pair) => Number.parseInt(pair, 16)).join(" ");
};

const createPalette = (palette) =>
  BRAND_COLOR_NAMES.reduce((accumulator, shade) => {
    accumulator[shade] = hexToRgbChannels(palette[shade]);
    return accumulator;
  }, {});

export const THEME_COLOR_STORAGE_KEY = "nf_theme_color";
export const DEFAULT_THEME_COLOR = "purple";

export const THEME_COLOR_OPTIONS = [
  { key: "purple", label: "Purple", swatch: "#7209B7" },
  { key: "blue", label: "Blue", swatch: "#3b82f6" },
  { key: "emerald", label: "Emerald", swatch: "#10b981" },
  { key: "rose", label: "Rose", swatch: "#f43f5e" },
  { key: "amber", label: "Amber", swatch: "#f59e0b" },
];

const THEME_PALETTES = {
  purple: createPalette({
    50: "#f5e8ff",
    100: "#ebd5ff",
    200: "#d9b2ff",
    300: "#c680ff",
    400: "#ad43f3",
    500: "#8f2bd9",
    600: "#7209B7",
    700: "#6508a4",
    800: "#52067f",
    900: "#3f045f",
    950: "#2d0343",
  }),
  blue: createPalette({
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
    950: "#172554",
  }),
  emerald: createPalette({
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b",
    950: "#022c22",
  }),
  rose: createPalette({
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337",
    950: "#4c0519",
  }),
  amber: createPalette({
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f",
    950: "#451a03",
  }),
};

export const getThemeColorPalette = (themeColor) =>
  THEME_PALETTES[themeColor] || THEME_PALETTES[DEFAULT_THEME_COLOR];

export const applyThemeColor = (themeColor) => {
  if (typeof document === "undefined") return;

  const palette = getThemeColorPalette(themeColor);
  const root = document.documentElement;

  Object.entries(palette).forEach(([shade, value]) => {
    root.style.setProperty(`--nf-brand-${shade}`, value);
  });
};
